// (부패) 문항 number에 따라서 상황이 할당됨
const contents = [
    {
        num: 11,
        content: '영희는 집안사정이 좋지 않아 어린나이에 집안의 생계를 책임지고 있습니다. \n최근에는 미스테리쇼퍼(매장에 들러서 손님으로 위장해, 특정 매장의 청결 상태 감시하는 일)라는 알바를 하고있습니다.\n 알바를 시작한지 꽤 되어서 그런지 눈치가 빠른 매장직원들은 영희가 미스테리쇼퍼라는 것을 알아챘습니다.\n 그래서 영희가 올때마다 공짜로 상품을 주거나 훨씬 친절하게 대하는 태도를 보였습니다.\n 이럴때 원칙상으로라면 미스테리쇼퍼는 다른 사람으로 교체되어야합니다. \n하지만 영희는 당장의 끼니를 걱정해야할 정도로 생계가 어렵습니다. \n 영희는 일자리를 잃고 싶지 않아 본사에 알리지 않았습니다.\n\n 영희가 부패하였다고 생각하십니까 ?',
    },
    {
        num: 12,
        content: '정수는 경상도의 작은 어촌 마을에서 근무하는 신입 순경입니다. \n어느 날 휴가를 낸 정수가 오랜만에 소꿉친구들을 만나 술자리를 가지게 됩니다. \n정수는 친한 친구들과의 오랜만의 회포이기에 친구들과 함께 만취를 하게 되고, 새벽에 대리기사를 부릅니다. \n하지만 대리기사는 주차장 입구에서 돈을 더 요구하고 이를 거절하니 그들을 길바닥에 두고 떠나버립니다. \n당황한 친구가 비틀거리며 차를 주차하기 위해 운전대를 잡게 되고, 정수는 이를 묵인했습니다.\n\n정수가 부패하였다고 생각하십니까 ?',
    },
    {
        num: 13,
        content: '수지씨는 한국도로공사의 직원입니다.\n 최근 수지씨는 국토교통부 도로국장인 도국씨의 아내인 지수가 운영하는 청소 환경업체와 용역을 체결하였습니다.\n 입찰은 나라장터에서 공개입찰 하였지만, 입찰자는 도국의 아내인 지수씨가 운영하는 환경업체 뿐이었습니다.\n\n수지가 부패하였다고 생각하십니까 ?',
    },
    {
        num: 14,
        content: '공무원인 철수는 만삭의 아내와 행복한 결혼 생활을 하고 있는 결혼 1년차인 신혼입니다. \n 철수는 엘리스 시청에서 야근을 하던 도중 아내에게  진통이 시작되어 병원 응급실로 가고 있다는 연락을 받게 됩니다. \n 너무 정신이 없는 철수는 택시를 타고 병원에 갔는데 아내의 상태가 심각하다는 말을 듣고 너무 다급한 나머지 카드를 두고와서 어쩔 수 없이 업무용 신용 카드로 택시비를 결제하게 되었습니다. \n\n철수가 부패하였다고 생각하십니까 ?',
    },
    {
        num: 15,
        content: '경찰관 재광은 광재와 친한 사이입니다. \n 어느날 교통 법규가 개정된다는 사실이 내부에서 소문이 돌았지만 공식발표는 아직입니다. \n 광재가 벌금을 내는 것을 피하기 위해 재광이 광재에게 미리 개정사안을 얘기해주었습니다.\n\n 재광이 부패하였다고 생각하십니까 ?'
    },
    {
        num: 16,
        content: '강남구 의회장인 종필씨는 최근 야근수당이 없어도 밤낮없이 일해서 성과평가 1등을 내어준 직원들이 고마웠습니다. \n 그래서 다가올 연말에 직원들에게 수고했다는 의미로 좋은 추억을 선물해주려 합니다.\n 그래서 직원들 몰래 1박2일 제주도 여행을 준비하였습니다. \n\n 종필씨가 부패하였다고 생각하십니까 ?',
    }
]
export default contents